/* Pialú — native product reviews widget (carousel + modal + filters + write form). */
(function () {
  'use strict';
  if (window.__pialuReviewsInit) return;
  window.__pialuReviewsInit = true;

  var MAX_PHOTO = 6 * 1024 * 1024; // 6 MB

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // iOS-safe scroll lock: freezing <html> overflow alone does NOT stop
  // background touch-scroll in Safari, so we pin the <body> and restore the
  // exact scroll position on unlock. Idempotent (guards repeated calls).
  var _lockY = 0;
  function lockScroll(on) {
    if (on === window.__prLocked) return;
    window.__prLocked = on;
    var h = document.documentElement, b = document.body;
    if (on) {
      _lockY = window.pageYOffset || h.scrollTop || 0;
      b.style.position = 'fixed';
      b.style.top = (-_lockY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      h.style.overflow = 'hidden';
    } else {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      h.style.overflow = '';
      window.scrollTo(0, _lockY);
    }
  }

  function initSection(root) {
    if (root.__prInit) return;
    root.__prInit = true;

    var modal = root.querySelector('[data-pr-modal]');
    var track = root.querySelector('[data-pr-track]');

    /* ---- carousel ---- */
    if (track) {
      var prev = root.querySelector('[data-pr-prev]');
      var next = root.querySelector('[data-pr-next]');
      var step = function () {
        var card = track.querySelector('.pr-card');
        return card ? card.getBoundingClientRect().width + 12 : 300;
      };
      var update = function () {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
      track.addEventListener('scroll', update, { passive: true });
      update();
      window.addEventListener('resize', update);
      // open modal when a compact card is clicked
      track.addEventListener('click', function (e) {
        var card = e.target.closest('.pr-card--compact');
        if (card && !e.target.closest('[data-pr-lightbox]')) openModal();
      });
      track.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.pr-card--compact')) {
          e.preventDefault(); openModal();
        }
      });
    }

    /* ---- modal open/close ---- */
    var _opener = null;
    function openModal() {
      if (!modal) return;
      /* Portail vers <body> : le modal est rendu dans .product__meta (position:sticky; z-index:1),
         un contexte d'empilement qui le piège SOUS le header sticky sur desktop (haut coupé). En le
         déplaçant à la racine, son z-index reprend effet au-dessus de tout. Réf. internes conservées. */
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      _opener = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      // move focus into the dialog (a11y; aria-modal promise)
      var c = modal.querySelector('[data-pr-close]');
      if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      hideForm();
      hideLightbox();
      if (_opener && _opener.focus) { try { _opener.focus({ preventScroll: true }); } catch (e) {} }
      _opener = null;
    }
    root.querySelectorAll('[data-pr-open]').forEach(function (b) {
      b.addEventListener('click', openModal);
    });
    if (modal) {
      modal.querySelectorAll('[data-pr-close]').forEach(function (b) {
        b.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    /* ---- filters ---- */
    var filtersBar = root.querySelector('[data-pr-filters]');
    if (filtersBar) {
      var list = root.querySelector('[data-pr-list]');
      var noRes = root.querySelector('[data-pr-noresults]');
      filtersBar.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-pr-filter]');
        if (!chip) return;
        filtersBar.querySelectorAll('.pr-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var f = chip.getAttribute('data-pr-filter');
        var shown = 0;
        list.querySelectorAll('[data-pr-card]').forEach(function (card) {
          var ok = true;
          if (f === 'photos') ok = parseInt(card.getAttribute('data-photos'), 10) > 0;
          else if (f !== 'all') ok = String(card.getAttribute('data-rating')) === f;
          card.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        if (noRes) noRes.hidden = shown !== 0;
      });
    }

    /* ---- lightbox ---- */
    var lb = root.querySelector('[data-pr-lightbox-box]');
    var lbImg = root.querySelector('[data-pr-lightbox-img]');
    function hideLightbox() { if (lb) { lb.hidden = true; lb.setAttribute('aria-hidden', 'true'); } }
    if (modal && lb) {
      modal.addEventListener('click', function (e) {
        var t = e.target.closest('[data-pr-lightbox]');
        if (t) { lbImg.src = t.getAttribute('data-pr-lightbox'); lb.hidden = false; lb.setAttribute('aria-hidden', 'false'); }
      });
      lb.querySelectorAll('[data-pr-lightbox-close]').forEach(function (b) { b.addEventListener('click', hideLightbox); });
      lb.addEventListener('click', function (e) { if (e.target === lb) hideLightbox(); });
    }

    /* ---- write form ---- */
    var formWrap = root.querySelector('[data-pr-form-wrap]');
    var form = root.querySelector('[data-pr-form]');
    var thanks = root.querySelector('[data-pr-thanks]');
    function showForm() { if (formWrap) { openModal(); formWrap.hidden = false; } }
    function hideForm() { if (formWrap) formWrap.hidden = true; }
    root.querySelectorAll('[data-pr-write-open]').forEach(function (b) { b.addEventListener('click', showForm); });
    root.querySelectorAll('[data-pr-write-close]').forEach(function (b) { b.addEventListener('click', hideForm); });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitReview(root, form, thanks);
    });
  }

  function fileToDataURL(file) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () { resolve(r.result); };
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }

  // Downscale to max 1280px and re-encode as JPEG. This shrinks the upload
  // 5-10x on 4G and normalizes iPhone HEIC photos (Safari decodes HEIC to the
  // canvas) to a format Shopify Files displays. Falls back to the raw file.
  function compressPhoto(file) {
    return new Promise(function (resolve) {
      function fallback() { fileToDataURL(file).then(resolve, function () { resolve(null); }); }
      try {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
          if (!w || !h) return fallback();
          var scale = Math.min(1, 1280 / Math.max(w, h));
          var cw = Math.round(w * scale), ch = Math.round(h * scale);
          var canvas = document.createElement('canvas');
          canvas.width = cw; canvas.height = ch;
          var ctx = canvas.getContext('2d');
          if (!ctx) return fallback();
          ctx.drawImage(img, 0, 0, cw, ch);
          try { resolve(canvas.toDataURL('image/jpeg', 0.82)); } catch (e) { fallback(); }
        };
        img.onerror = function () { URL.revokeObjectURL(url); fallback(); };
        img.src = url;
      } catch (e) { fallback(); }
    });
  }

  function submitReview(root, form, thanks) {
    var msg = form.querySelector('[data-pr-msg]');
    var btn = form.querySelector('[data-pr-submit]');
    var endpoint = root.getAttribute('data-endpoint');

    function fail(text) {
      if (msg) { msg.textContent = text; msg.hidden = false; msg.classList.add('is-error'); }
    }
    if (msg) { msg.hidden = true; msg.classList.remove('is-error'); }

    var fd = new FormData(form);
    var rating = fd.get('rating');
    if (!rating) return fail('Por favor, elige una puntuación con las estrellas.');
    if (!String(fd.get('title') || '').trim()) return fail('Escribe un título para tu reseña.');
    if (!String(fd.get('body') || '').trim()) return fail('Escribe el texto de tu reseña.');
    if (!String(fd.get('first_name') || '').trim()) return fail('Indica tu nombre.');
    var email = String(fd.get('email') || '').trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Indica un correo electrónico válido.');
    if (!endpoint) return fail('El formulario no está disponible por ahora. Inténtalo más tarde.');

    var payload = {
      product_id: root.getAttribute('data-product-id'),
      product_handle: root.getAttribute('data-product-handle'),
      product_title: root.getAttribute('data-product-title'),
      rating: parseInt(rating, 10),
      title: String(fd.get('title') || '').trim(),
      body: String(fd.get('body') || '').trim(),
      fitting: fd.get('fitting') || '',
      recommended: fd.get('recommended') || '',
      first_name: String(fd.get('first_name') || '').trim(),
      last_name: String(fd.get('last_name') || '').trim(),
      email: email,
      website: fd.get('website') || '',
      ts: new Date().toISOString()
    };

    var photoFile = form.querySelector('[data-pr-photo]') ? form.querySelector('[data-pr-photo]').files[0] : null;

    var send = function () {
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.ok) {
            if (thanks) {
              form.style.display = 'none';
              thanks.hidden = false;
            }
          } else {
            if (btn) { btn.disabled = false; btn.textContent = 'Publicar'; }
            fail((data && data.error) || 'No pudimos enviar tu reseña. Inténtalo de nuevo.');
          }
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Publicar'; }
          fail('No pudimos enviar tu reseña. Revisa tu conexión e inténtalo de nuevo.');
        });
    };

    if (photoFile) {
      if (photoFile.size > MAX_PHOTO) return fail('La foto es demasiado grande (máx. 6 MB).');
      if (btn) { btn.disabled = true; btn.textContent = 'Procesando foto…'; }
      compressPhoto(photoFile).then(function (durl) {
        if (durl) { payload.photo = durl; payload.photo_name = 'resena.jpg'; }
        send();
      });
    } else {
      send();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-pialu-reviews]').forEach(initSection);
    // Theme editor: re-init on section load
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector ? e.target.querySelector('[data-pialu-reviews]') : null;
      if (r) initSection(r);
    });
  });
})();
